<template>
    <div>
        <div v-if="loading" class="text-center" style="padding: 40px 0;">
            <font-awesome-icon :icon="['fas', 'spinner']" spin size="2x" />
        </div>
        <div v-else>
            <div class="row">
                <div class="col-md-5">
                    <div class="card w-100 margin-botton-20 border-0" style="width: 18rem;">
                        <div class="card-body border-primary">
                            <h3 class="h5 card-title">Moon</h3>
                            <p class="card-text">
                                <MoonGraph
                                    :illumination="moonIllumination.illumination"
                                    :moon-phase-name="moonIllumination.moon_phase_name"
                                    :altitude="moonAltitudeAzimuth.altitude != null ? moonAltitudeAzimuth.altitude : null"
                                    :azimuth="moonAltitudeAzimuth.azimuth != null ? moonAltitudeAzimuth.azimuth : null"
                                    :lat="latitude"
                                />
                            </p>
                            <p class="card-text">
                                {{ moonIllumination.formatted_illumination }}
                                <br>{{ moonIllumination.moon_phase_name }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-7">
                    <div class="row margin-botton-20" style="margin-top: 20px;">
                        <div class="col-md-12">
                            <div class="row themed" style="font-size: 92%;">
                                <div class="col-md-6">Previous Phase:</div>
                                <div class="col-md-6" v-if="moonIllumination.current_primary_phase">
                                    {{ moonIllumination.current_primary_phase.name }}
                                    <br><small>{{ moonIllumination.current_primary_phase.naturalday }} at {{ moonIllumination.current_primary_phase.time }}</small>
                                </div>
                            </div>
                            <div class="row themed">
                                <div class="col-md-6">Current Phase:</div>
                                <div class="col-md-6" v-if="moonIllumination.current_primary_phase">
                                    {{ moonIllumination.moon_phase_name }}
                                    <br><small>Duration: {{ moonIllumination.current_primary_phase.duration_days }} days</small>
                                </div>
                            </div>
                            <div class="row themed" style="font-size: 92%;">
                                <div class="col-md-6">Next Phase:</div>
                                <div class="col-md-6" v-if="moonIllumination.next_primary_phase">
                                    {{ moonIllumination.next_primary_phase.name }}
                                    <br><small>{{ moonIllumination.next_primary_phase.naturalday }} at {{ moonIllumination.next_primary_phase.time }}</small>
                                </div>
                            </div>
                            <div class="row themed">
                                <div class="col-md-6">When:</div>
                                <div class="col-md-6">
                                    <span v-if="useNoon">Noon</span><a v-else href="#" @click.prevent="setNoon">Noon</a>
                                    &nbsp;/&nbsp;
                                    <a v-if="useNoon" href="#" @click.prevent="setNow">Now</a><span v-else>Now</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3" v-for="event in moonPhases" :key="event.id">
                    <div class="card w-100 margin-botton-20" style="width: 18rem;">
                        <div class="card-body event-card-bg">
                            <h3 class="h5 card-title">{{ event.name }}</h3>
                            <p class="card-text"><img :src="getImageUrl(event.type)" /></p>
                            <p class="card-text">{{ event.short_literal_date }} at {{ event.time }}</p>
                            <p class="card-text small">{{ event.naturaltime }}</p>
                            <p class="card-text small">Duration {{ event.duration_days }} days</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3" v-if="moonIlluminationMonthly.length">
                <div class="col-12">
                    <div class="card w-100 margin-botton-20">
                        <div class="card-body event-card-bg">
                            <MoonPhaseChartTemp :days="moonIlluminationMonthly" :phases="moonPhases" title="Moon Phases" :subtitle="chartSubtitle" :subtitle2="chartSubtitle2" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3" v-if="moonPhaseMonthlyRows.length">
                <div class="col-12">
                    <div class="card w-100 margin-botton-20">
                        <div class="card-body event-card-bg">
                            <h3 class="h4 card-title mb-3">{{ currentMonthLabel }}</h3>
                            <div class="table-responsive">
                            <table class="table table-sm mb-0">
                                <thead>
                                    <tr>
                                        <th>Day</th>
                                        <th class="text-start">Phase</th>
                                        <th>Time</th>
                                        <th class="text-end">Illum.%</th>
                                        <th class="text-end">Phase °</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(row, index) in moonPhaseMonthlyRows" :key="index"
                                        :class="date && parseInt(row.day) === date.getDate() ? 'table-success' : (row.isEvent ? 'table-warning' : '')"
                                        :style="date && parseInt(row.day) === date.getDate() ? { '--bs-table-bg': 'rgba(25,135,84,0.15)', '--bs-table-border-color': 'transparent' } : (row.isEvent ? { '--bs-table-bg': 'rgba(255,193,7,0.12)' } : {})">
                                        <td>{{ row.day }}</td>
                                        <td class="text-start">{{ row.phase }}</td>
                                        <td>{{ row.time }}</td>
                                        <td class="text-end">{{ row.illumination }}</td>
                                        <td class="text-end">{{ row.phase_angle }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import astroTabMixin from '@/mixins/astroTab'
import astra from '@/api/astra'
import client from '@/api/client'
import { formatDate } from '@/utils/format'
import MoonGraph from './MoonGraph'
import MoonPhaseChartTemp from './MoonPhaseChartTemp'

export default {
    name: 'TabMoonPhases',
    mixins: [astroTabMixin],
    components: { MoonGraph, MoonPhaseChartTemp },
    props: {
        active: { type: Boolean, default: false },
    },
    data() {
        return {
            loading: true,
            moonPhases: [],
            moonIllumination: {},
            moonIlluminationMonthly: [],
            moonAltitudeAzimuth: {},
        }
    },
    computed: {
        chartSubtitle() {
            if (!this.city || !this.city.name) return ''
            const parts = [this.city.name]
            if (this.city.region_name) parts.push(this.city.region_name)
            return 'near ' + parts.join(', ')
        },
        chartSubtitle2() {
            if (!this.date) return ''
            return 'for ' + this.date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
        },
        moonPhaseMonthlyRows() {
            const PHASE_ILLUMINATION = { 0: 0, 1: 50, 2: 100, 3: 50 }
            const fmtIllum = pct => Number(pct).toPrecision(3) + '%'
            const eventMap = {}
            for (const event of this.moonPhases) {
                eventMap[event.short_date] = event
            }
            const rows = []
            for (const item of this.moonIlluminationMonthly) {
                const day = item.short_date.split('-')[2]
                const event = eventMap[item.short_date]
                if (event) {
                    rows.push({
                        day,
                        phase: (event.symbol ? event.symbol + ' ' : '') + event.name,
                        time: event.time.replace(/\s+(am|pm)$/i, '$1'),
                        illumination: event.type in PHASE_ILLUMINATION ? fmtIllum(PHASE_ILLUMINATION[event.type]) : '—',
                        phase_angle: event.phase_angle != null ? event.phase_angle + '°' : '—',
                        isEvent: true,
                    })
                } else {
                    rows.push({
                        day,
                        phase: (item.moon_phase_symbol ? item.moon_phase_symbol + ' ' : '') + (item.moon_phase_name || ''),
                        time: '12:00am',
                        illumination: fmtIllum(item.illumination_percentage),
                        phase_angle: item.phase_angle != null ? item.phase_angle + '°' : '—',
                        isEvent: false,
                    })
                }
            }
            return rows
        },
    },
    watch: {
        active(val) { if (val) this.load() },
        city()      { if (this.active) this.load() },
        date()      { if (this.active) this.load() },
    },
    mounted() {
        if (this.active) this.load()
    },
    methods: {
        getImageUrl(index) {
            return `${client.defaults.baseURL}astra/moon/phase-png/${index}`
        },
        async load() {
            if (!this.latitude || !this.longitude || !this.timezone) return
            if (this.apiLocked) return
            this.loading = true
            const m1 = new Date(this.date.getFullYear(), this.date.getMonth(), 1)
            const m2 = new Date(m1)
            m2.setMonth(m1.getMonth() + 1)
            await Promise.allSettled([
                astra.fetchMoonPhases({ ...this.loc, ...this.monthlyRange }).then(r => { this.moonPhases = r.data.events }),
                astra.fetchMoonIllumination({ ...this.loc, date1: formatDate(m1), date2: formatDate(m2) }).then(r => { this.moonIlluminationMonthly = r.data.events || [] }),
                astra.fetchMoonIllumination({ ...this.loc, date1: this.dailyTimeRange.date1 }).then(r => { this.moonIllumination = r.data }),
            ])
            this.loading = false
        },
    },
}
</script>

<style scoped>
.themed {
    margin: 5px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
    padding-bottom: 10px;
    padding-top: 10px;
}
.margin-botton-20 { margin-bottom: 20px; }
.table-responsive td,
.table-responsive th { white-space: nowrap; }
</style>
